<template>
  <div class="page-container">
    <div class="main">
      <page
          :url="url"
          :form="form"
          @reset="reset"
          @select-data="handleSelectionChange"
      >
        <template slot="tableSearch">
          <el-form-item :label="$t('text.upstream')">
            <el-select v-model="form.upstream"
                       style="width: 120px"
                       :placeholder="$t('message.chooseOne')">
              <el-option label="全部" value=""></el-option>
              <el-option label="Easypaisa" value="easypaisa"></el-option>
              <el-option label="Jazzcash" value="jazzcash"></el-option>
              <el-option label="CardGroup" value="card_group"></el-option>
              <el-option label="Ajar" value="ajar"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.creationTime')">
            <el-date-picker
                v-model="timeDate"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyyMMdd"
                :range-separator="$t('text.to')"
                :start-placeholder="$t('text.startDate')"
                :end-placeholder="$t('text.endDate')"
                @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.export') }}
          </el-button>
        </template>

        <template slot="tableColumn">

          <el-table-column
              width="100"
              prop="statisticsDate"
              :label="$t('text.date')"
              :formatter="$formatter.formatDate"
              align="center"
          ></el-table-column>

          <el-table-column
              prop="upstream"
              :label="$t('text.upstream')"
              width="120px"
              align="center"
          >
          </el-table-column>

          <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

          <el-table-column
              width="140px"
              prop="payInAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.collectionAmount')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="payInMerFee"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.collectionRevenue')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="payInFee"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.collectionCost')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="payInTotalAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.collectionGrossProfit')"
              align="center"
          ></el-table-column>

          <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

          <el-table-column
              width="140px"
              prop="payOutAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.disbursementAmount')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="payOutMerFee"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.disbursementRevenue')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="payOutFee"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.disbursementCost')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="payOutTotalAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.disbursementGrossProfit')"
              align="center"
          ></el-table-column>

          <el-table-column prop="" width="20px" label="|" align="center">|</el-table-column>

          <el-table-column
              width="140px"
              prop="totalTransactionAmount"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.payAmountTotal')"
              align="center"
          ></el-table-column>

          <el-table-column
              width="140px"
              prop="totalGrossProfit"
              :formatter="$formatter.FenToYuanToThousandth"
              :label="$t('text.payGrossProfitTotal')"
              align="center"
          ></el-table-column>

        </template>
      </page>
      <pk_route_config_inf_edit
          :show.sync="showDialog"
          :value="value"
          :action="action"
          v-if="this.$store.state.isPK"
      ></pk_route_config_inf_edit>

      <bd_route_config_inf_edit
          :show.sync="showDialog"
          :value="value"
          :action="action"
          v-if="this.$store.state.isBD"
      ></bd_route_config_inf_edit>

      <PkBatchRouteUpdate
          :show.sync="showBatchDialog"
          :value="strMultipleSelection"
          :action="action"
          v-if="this.$store.state.isPK"
      />

      <BdBatchRouteUpdate
          :show.sync="showBatchDialog"
          :value="strMultipleSelection"
          :action="action"
          v-if="this.$store.state.isBD"
      />
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import PkRouteConfigInfoEdit from "./routeConfigInfo/PkRouteConfigInfoEdit.vue";
import PkBatchRouteUpdate from "./routeConfigInfo/PkBatchRouteUpdate.vue";
import BdBatchRouteUpdate from "./routeConfigInfo/BdBatchRouteUpdate.vue";
import {
  PAYMENT_TYPE_ID_COLLECTION,
  PAYMENT_TYPE_ID_PAYMENT
} from "@/utils/Constant";
import moment from "moment/moment";
import BdRouteConfigInfoEdit from "@/views/route/routeConfigInfo/BdRouteConfigInfoEdit.vue";

export default {
  name: "route",
  components: {
    page: Page,
    pk_route_config_inf_edit: PkRouteConfigInfoEdit,
    bd_route_config_inf_edit: BdRouteConfigInfoEdit,
    PkBatchRouteUpdate: PkBatchRouteUpdate,
    BdBatchRouteUpdate: BdBatchRouteUpdate
  },
  data() {
    return {
      PAYMENT_TYPE_ID_COLLECTION,
      PAYMENT_TYPE_ID_PAYMENT,
      timeDate: [moment().subtract(0, 'days').format('yyyyMMDD'),moment().format('yyyyMMDD')],
      multipleSelection: [],
      strMultipleSelection: [],
      url: "/statistics-channel/upstream-statistics",
      action: "",
      form: {
        routeStatus: "",
        startDate: moment().subtract(0, 'days').format('yyyyMMDD'),
        endDate: moment().format('yyyyMMDD'),
      },
      showDialog: false,
      showBatchDialog: false,
      formLabelWidth: "100px",
      formData: null,
      value: {},
      upstreamList: [],
      loading: false,
      exporting: false,
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.strMultipleSelection = this.multipleSelection.map(
          ({ routeId }) => routeId
      );
    },
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      let start = moment().subtract(3, 'days').format('yyyyMMDD');
      let end = moment().format('yyyyMMDD');
      this.form.startDate = start;
      this.form.endDate = end;
      this.timeDate = [start, end];
    },
    exportDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/statistics-channel/upstream-statistics/export", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.upstreamStatisticsExport'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res.text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
  },
  created() {
    this.$axios
        .get("/order/orderPayment/selectPackagedUpstream", {params: {}})
        .then((res) => {
          this.upstreamList = res.data;
        });
  },
};
</script>
